module.exports = __webpack_public_path__ + "static/media/templateActiveIcon-newer.8d58febb.svg";